/**
 * Sdílená tabule (KanbanControl) – mechanika převzatá z Tabule obchodů:
 * jQuery UI sortable mezi sloupci jednoho pruhu, šipky pro posun o sloupec,
 * pořadí karet ve sloupci v localStorage.
 *
 * Změny se posílají jako JSON na signály controlu (move / op / card /
 * loadMore). Karta se přesune hned a při chybě se vrátí na původní místo
 * s hláškou. Chování konkrétní tabule (editory na kartě úkolu…) přidává
 * Kanban.registerBehaviour(type, fn), viz kanban-tasks.js.
 */
(function ($) {
    "use strict";

    var boards = {};
    var behaviours = {};

    function Board(root) {
        this.root = root;
        this.$root = $(root);
        this.config = this.$root.data("kanban");
        this.orderKey = "kanban." + this.config.boardId + "." + this.config.userId + ".order";
    }

    Board.prototype.init = function () {
        this.restoreOrder();
        if (!this.config.readOnly) {
            this.initSortable();
        }
        this.bindEvents();
        this.refreshArrows();

        var behaviour = behaviours[this.config.type];
        if (behaviour) {
            behaviour(this);
        }
    };

    Board.prototype.t = function (key) {
        return (this.config.i18n && this.config.i18n[key]) || key;
    };

    // ---------------------------------------------------------------- requests

    Board.prototype.request = function (endpoint, body, method) {
        var deferred = $.Deferred();
        var settings = {
            url: this.config.endpoints[endpoint],
            type: method || "POST",
            dataType: "json",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        };
        if (settings.type === "POST") {
            settings.contentType = "application/json";
            settings.data = JSON.stringify(body || {});
        } else {
            settings.data = body || {};
        }

        var board = this;
        $.ajax(settings)
            .done(function (response) {
                if (response && response.status === "ok") {
                    deferred.resolve(response);
                } else {
                    deferred.reject(response && response.message ? response.message : board.t("error"));
                }
            })
            .fail(function (xhr) {
                var message = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : board.t("error");
                deferred.reject(message, xhr.status);
            });

        return deferred.promise();
    };

    /** Akce nad kartou; výsledek (změněná / nová / odebraná karta) se rovnou promítne. */
    Board.prototype.op = function (id, op, payload) {
        var board = this;
        var $card = this.findCard(id);
        $card.addClass("kb-pending");

        return this.request("op", { op: op, id: id, payload: payload || {} })
            .done(function (response) {
                board.applyResponse(response);
            })
            .fail(function (message, status) {
                board.toastError(message);
                if (status === 404) {
                    board.removeCard(id);
                }
            })
            .always(function () {
                $card.removeClass("kb-pending");
            });
    };

    Board.prototype.applyResponse = function (response) {
        if (response.card) {
            this.applyCard(response.card);
        }
        if (response.created) {
            this.insertCard(response.created, response.card ? response.card.id : null);
        }
        if (response.removed) {
            this.removeCard(response.removed);
        }
    };

    // ------------------------------------------------------------- DOM helpers

    Board.prototype.findCard = function (id) {
        return this.$root.find('.kb-card[data-id="' + id + '"]');
    };

    Board.prototype.findList = function (lane, column) {
        return this.$root.find('.kb-list[data-lane="' + lane + '"][data-column="' + column + '"]');
    };

    /** Nahradí kartu novým HTML; když se změnil sloupec/pruh, přesune ji tam. */
    Board.prototype.applyCard = function (card) {
        var $old = this.findCard(card.id);
        var $new = $(card.html);
        var $targetList = this.findList(card.lane, card.column);

        if ($old.length && $old.parent()[0] === $targetList[0]) {
            $old.replaceWith($new);
        } else {
            if ($old.length) {
                this.adjustCount($old.parent(), -1);
                $old.remove();
            }
            if ($targetList.length) {
                $targetList.prepend($new);
                this.adjustCount($targetList, 1);
            }
        }

        this.refreshArrows();
        this.saveOrder();
        return $new;
    };

    Board.prototype.insertCard = function (card, afterId) {
        if (this.findCard(card.id).length) {
            return this.applyCard(card);
        }
        var $new = $(card.html);
        var $list = this.findList(card.lane, card.column);
        var $after = afterId ? this.findCard(afterId) : $();

        if ($after.length && $after.parent()[0] === $list[0]) {
            $after.after($new);
        } else {
            $list.prepend($new);
        }
        this.adjustCount($list, 1);
        this.refreshArrows();
        this.saveOrder();
        return $new;
    };

    Board.prototype.removeCard = function (id) {
        var $card = this.findCard(id);
        if (!$card.length) {
            return;
        }
        this.adjustCount($card.parent(), -1);
        $card.remove();
        this.refreshArrows();
        this.saveOrder();
    };

    Board.prototype.adjustCount = function ($list, delta) {
        var $count = $list.closest(".kb-column").find(".kb-count");
        var total = Math.max(0, (parseInt($count.attr("data-total"), 10) || 0) + delta);
        $count.attr("data-total", total).text(total);
    };

    /**
     * Šipky ◀ ▶: v prvním / posledním sloupci pruhu skryté (stejně jako na Tabuli).
     * Zároveň přepne text "Žádné karty" u sloupců bez karet.
     */
    Board.prototype.refreshArrows = function () {
        this.$root.find(".kb-lane").each(function () {
            var $columns = $(this).find(".kb-column");
            $columns.each(function (index) {
                $(this).find('[data-kb-move="prev"]').toggle(index > 0);
                $(this).find('[data-kb-move="next"]').toggle(index < $columns.length - 1);
                $(this).toggleClass("is-empty", !$(this).find(".kb-list > .kb-card").length);
            });
        });
    };

    Board.prototype.toastError = function (message) {
        if (typeof window.flashMessage === "function") {
            window.flashMessage(message || this.t("error"), "r");
        }
    };

    // ------------------------------------------------------------ drag & drop

    Board.prototype.initSortable = function () {
        var board = this;
        var touch = "ontouchstart" in window;
        // Na telefonu se táhne jen za úchyt – jinak touch-punch zablokuje
        // posouvání stránky i sloupců prstem, který začne na kartě.
        var coarse = !!(window.matchMedia && window.matchMedia("(hover: none) and (pointer: coarse)").matches);

        this.$root.find(".kb-lane").each(function () {
            var lane = $(this).data("lane");
            var $lists = $(this).find(".kb-list");

            $lists.sortable({
                connectWith: board.$root.find('.kb-list[data-lane="' + lane + '"]'),
                items: "> .kb-card:not(.kb-locked)",
                placeholder: "kb-placeholder",
                forcePlaceholderSize: true,
                revert: 100,
                tolerance: "pointer",
                handle: coarse ? ".kb-handle" : false,
                delay: touch && !coarse ? 150 : 0,
                cancel: "a, button, input, textarea, select, [contenteditable], .kb-pending, .dropdown-menu",
                start: function (event, ui) {
                    ui.item.data("kbOrigin", {
                        list: ui.item.parent()[0],
                        index: ui.item.index(),
                    });
                },
                update: function (event, ui) {
                    // update chodí z obou seznamů – zpracujeme jen ten cílový
                    if (this !== ui.item.parent()[0]) {
                        return;
                    }
                    var origin = ui.item.data("kbOrigin");
                    board.saveOrder();
                    if (origin && origin.list !== this) {
                        board.move(ui.item, $(this), origin);
                    }
                },
            });
        });
    };

    /** Optimistický přesun: karta už je v cílovém sloupci, server to potvrdí nebo vrátíme. */
    Board.prototype.move = function ($card, $toList, origin) {
        var board = this;
        var id = $card.data("id");
        var $fromList = $(origin.list);

        this.adjustCount($fromList, -1);
        this.adjustCount($toList, 1);
        $card.addClass("kb-pending");

        this.request("move", {
            id: id,
            lane: $toList.data("lane"),
            column: $toList.data("column"),
        })
            .done(function (response) {
                board.applyCard(response.card);
            })
            .fail(function (message, status) {
                board.toastError(message);
                board.adjustCount($toList, -1);
                if (status === 404) {
                    $card.remove();
                    board.refreshArrows();
                    board.saveOrder();
                    return;
                }
                board.adjustCount($fromList, 1);
                var $siblings = $fromList.children(".kb-card").not($card);
                if (origin.index >= $siblings.length) {
                    $fromList.append($card);
                } else {
                    $siblings.eq(origin.index).before($card);
                }
                $card.removeClass("kb-pending");
                board.refreshArrows();
                board.saveOrder();
            });
    };

    Board.prototype.moveByArrow = function ($card, direction) {
        var $column = $card.closest(".kb-column");
        var $target = direction === "prev" ? $column.prev(".kb-column") : $column.next(".kb-column");
        if (!$target.length) {
            return;
        }
        var origin = { list: $card.parent()[0], index: $card.index() };
        var $toList = $target.find(".kb-list");
        $toList.prepend($card);
        this.refreshArrows();
        this.move($card, $toList, origin);
    };

    // ---------------------------------------------------------------- pořadí

    Board.prototype.saveOrder = function () {
        var order = {};
        this.$root.find(".kb-list").each(function () {
            var key = $(this).data("lane") + "|" + $(this).data("column");
            order[key] = $(this).children(".kb-card").map(function () {
                return $(this).data("id");
            }).get();
        });
        try {
            localStorage.setItem(this.orderKey, JSON.stringify(order));
        } catch (e) {
            // plné nebo zakázané úložiště – pořadí se prostě nepamatuje
        }
    };

    Board.prototype.restoreOrder = function () {
        var order = null;
        try {
            order = JSON.parse(localStorage.getItem(this.orderKey) || "null");
        } catch (e) {
            order = null;
        }
        if (!order) {
            return;
        }
        var board = this;
        $.each(order, function (key, ids) {
            var parts = key.split("|");
            var $list = board.findList(parts[0], parts[1]);
            // pořadí z localStorage jen přeskládá karty, které v daném sloupci jsou;
            // nové (neuložené) karty zůstanou nahoře
            $.each(ids, function (i, id) {
                var $card = $list.children('.kb-card[data-id="' + id + '"]');
                if ($card.length) {
                    $list.append($card);
                }
            });
            $list.children(".kb-card").filter(function () {
                return ids.indexOf($(this).data("id")) === -1;
            }).prependTo($list);
        });
    };

    // ---------------------------------------------------------------- události

    Board.prototype.bindEvents = function () {
        var board = this;

        // Menu karty ("…") s pozicí fixed, jinak ho ořízne vodorovně posuvný
        // pás sloupců. Nastaví se před tím, než si Bootstrap dropdown založí.
        this.$root.on("click", '[data-toggle="dropdown"]', function () {
            if (!$(this).data("bs.dropdown")) {
                $(this).data("popperConfig", { positionFixed: true });
            }
        });

        this.$root.on("click", "[data-kb-move]", function (e) {
            e.preventDefault();
            board.moveByArrow($(this).closest(".kb-card"), $(this).data("kb-move"));
        });

        this.$root.on("click", ".kb-load-more", function (e) {
            e.preventDefault();
            var $button = $(this);
            var $column = $button.closest(".kb-column");
            var $list = $column.find(".kb-list");
            $button.prop("disabled", true);

            // Offset = karty, které ve sloupci opravdu jsou (karty se mezitím
            // mohly přesunout sem nebo pryč); už zobrazené karty se nepřidají znovu.
            board.request("loadMore", {
                lane: $list.data("lane"),
                column: $list.data("column"),
                offset: $list.children(".kb-card").length,
            })
                .done(function (response) {
                    $("<div>").html(response.html).children(".kb-card").each(function () {
                        if (!board.findCard($(this).data("id")).length) {
                            $list.append(this);
                        }
                    });
                    if (!response.hasMore) {
                        $button.remove();
                    }
                    board.refreshArrows();
                })
                .fail(function (message) {
                    board.toastError(message);
                })
                .always(function () {
                    $button.prop("disabled", false);
                });
        });

        // Jednoduché akce bez editoru: data-kb-op="…" (+ data-* jako payload)
        this.$root.on("click", "[data-kb-op]", function (e) {
            e.preventDefault();
            var $el = $(this);
            var $card = $el.closest(".kb-card");
            var op = $el.data("kb-op");
            board.op($card.data("id"), op, board.payloadFor(op, $el));
        });
    };

    /** Payload pro data-kb-op tlačítka (doplňují behaviours přes board.payloadBuilders). */
    Board.prototype.payloadFor = function (op, $el) {
        if (this.payloadBuilders && this.payloadBuilders[op]) {
            return this.payloadBuilders[op]($el);
        }
        return {};
    };

    // ------------------------------------------------------------------ API

    window.Kanban = {
        init: function (root) {
            if (!root || root.getAttribute("data-kb-ready")) {
                return boards[root && root.id];
            }
            root.setAttribute("data-kb-ready", "1");
            var board = new Board(root);
            boards[root.id] = board;
            board.init();
            return board;
        },
        autoInit: function (context) {
            $(context || document).find("[data-kanban]").each(function () {
                window.Kanban.init(this);
            });
        },
        get: function (boardId) {
            return boards["kanban-" + boardId];
        },
        registerBehaviour: function (type, fn) {
            behaviours[type] = fn;
        },
    };

    $(function () {
        window.Kanban.autoInit(document);
    });

    // Tabule uvnitř překresleného snippetu se znovu inicializuje.
    if ($.nette && $.nette.ext) {
        $.nette.ext("kanban", {
            complete: function () {
                window.Kanban.autoInit(document);
            },
        });
    }
})(jQuery);
